<template>
  <div class="footer-wrapper large-shadow">
    <div class="footer">
      <a :href="METIME_URL" class="footer-logo-wrapper">
        <img src="../../assets/images/svg/logo.svg" alt="MeTime Logo" />
      </a>

      <div class="footer-address-wrapper">
        <div class="footer-address">
          <div class="footer-address__text">
            <div class="footer-address__text__address">
              <p>{{ data.companyName }}</p>

              <p>{{ data.firstLineAddress }}</p>

              <p>{{ data.secondLineAddress }}</p>
            </div>

            <a
              :href="'mailto:' + data.email"
              class="footer-address__text__support"
            >
              {{ data.email }}
            </a>
          </div>

          <div class="footer-address__images">
            <img
              :src="data.gdprImgSrc"
              width="128px"
              height="51px"
              alt="gdpr-compliance-image"
            />

            <img
              :src="data.hipaaImgSrc"
              width="96px"
              height="51px"
              alt="hipaa-compliance-image"
            />
          </div>
        </div>

        <div class="footer-rights">
          {{ data.rights }}
        </div>
      </div>

      <div class="footer-links-wrapper">
        <div class="footer-links">
          <div
            v-for="(link, index) in data.links"
            :key="index"
            class="footer-links__group"
          >
            <div class="footer-links__label">
              {{ link.group }}
            </div>

            <div class="footer-links__items">
              <a
                v-for="(item, itemIndex) in link.items"
                :key="itemIndex"
                class="footer-links__item"
                :href="item.link"
              >
                {{ item.label }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-socials-and-accreditation">
        <div class="footer-badges">
          <a :href="data.bestMobileAppImg.url">
            <img
              :src="data.bestMobileAppImg.src"
              alt="Best Mobile App image"
              :style="{
                width:
                  vssWidth < LAYOUT_BREAKPOINTS.LARGE
                    ? data.bestMobileAppImg.mobileWidth
                    : data.bestMobileAppImg.width + 'px',
                height:
                  vssWidth < LAYOUT_BREAKPOINTS.LARGE
                    ? data.bestMobileAppImg.mobileHeight
                    : data.bestMobileAppImg.height + 'px',
              }"
            />
          </a>

          <a :href="data.accreditationImg.url">
            <img
              :src="data.accreditationImg.src"
              alt="Best Mobile App image"
              :style="{
                width:
                  vssWidth < LAYOUT_BREAKPOINTS.LARGE
                    ? data.accreditationImg.mobileWidth
                    : data.accreditationImg.width + 'px',
                height:
                  vssWidth < LAYOUT_BREAKPOINTS.LARGE
                    ? data.accreditationImg.mobileHeight
                    : data.accreditationImg.height + 'px',
              }"
            />
          </a>
        </div>

        <div class="footer-socials-wrapper">
          <div class="footer-socials">
            <a
              v-for="(social, index) in data.socials"
              :key="index"
              :href="social.link"
              class="footer-socials__item"
              :title="social.name"
            >
              <img
                :src="social.icon"
                width="36px"
                height="36px"
                :alt="social.name"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { METIME_URL } from "@/const.js";
import data from "./data";
import { LAYOUT_BREAKPOINTS } from "@/const/layoutBreakpoints";
import { useScreenSize } from "@/components/composables/useScreenSize";

const { vssWidth } = useScreenSize();
</script>
